import { createSlice, createAsyncThunk, isAnyOf } from '@reduxjs/toolkit';
import { showToast } from 'Core/redux/toast/slice';
import { closeModal, showModal } from 'Core/redux/main/slice';
import { redux } from 'Core/redux';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import { MoldService } from '../../../service/api/mold-service';

const { MOLDRECEIVING_ADD_EDIT } = MODAL_TYPES;

export const STORE_KEY = 'moldreceiving';
export const INITIAL_STATE = {
  data: [],
  loading: false,
  error: null,
  filters: {
    searchText: '',
    fromDate: null,
    toDate: null,
    isReleased: 0,
  },
  receiveLoading: false,
  filterVisible: false,
  tileView: false,
  selectedMold: null,
  editModalVisible: false,
};

export const fetchMolds = createAsyncThunk(
  'mold/fetchMolds',
  async (filters, { rejectWithValue }) => {
    try {
      const response = await MoldService.getAllMold(filters);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to load mold receiving');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to load  mold receiving');
    }
  },
);

export const fetchMoldsByStatus = createAsyncThunk(
  'mold/fetchMoldsByStatus',
  async (filters, { rejectWithValue }) => {
    try {
      const response = await MoldService.getAllMoldByStatus(filters.isReleased);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to load mold receiving');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to load  mold receiving');
    }
  },
);

export const addMold = createAsyncThunk(
  'mold/addMold',
  async (moldPayload, { rejectWithValue }) => {
    try {
      // Return the static mold data
      const response = await MoldService.saveUpdateReceiving(moldPayload);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to add mold receiving');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to add mold receiving');
    }
  },
);

export const editMold = createAsyncThunk(
  'mold/editMold',
  async (moldPayload, { rejectWithValue }) => {
    try {
      const response = await MoldService.saveUpdateReceiving(moldPayload);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to update mold receiving');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to update mold receiving');
    }
  },
);

export const editMoldData = createAsyncThunk(
  'mold/editMoldData',
  async (id, { rejectWithValue }) => {
    try {
      const response = await MoldService.getMoldByToolIdWithCategory(id, 'Mold-Receiving');
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(
          response.errorMessage?.message || 'Failed to load mold receiving data',
        );
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to load mold receiving data');
    }
  },
);

export const fetchMoldReceivingWithFilters = () => (dispatch, getState) => {
  const filters = getState().moldreceiving.filters;
  dispatch(
    fetchMolds({
      searchText: filters.searchText,
      fromDate: filters?.fromDate,
      toDate: filters?.toDate,
    }),
  );
};

export const fetchMoldReceivingWithStatus = () => (dispatch, getState) => {
const filters = getState().moldreceiving.filters;
  dispatch(
    fetchMoldsByStatus({
      isReleased:filters?.isReleased
    }),
  );
};

export const { reducer, actions } = createSlice({
  name: 'mold',
  initialState: INITIAL_STATE,
  reducers: {
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    resetFilters: state => {
      state.filters = INITIAL_STATE.filters;
    },
    setFilterVisible: (state, action) => {
      state.filterVisible = action.payload;
    },
    setSearchText: (state, action) => {
      state.filters.searchText = action.payload;
    },
    setFromDate: (state, action) => {
      state.filters.fromDate = action.payload;
    },
    setToDate: (state, action) => {
      state.filters.toDate = action.payload;
    },
    setStatus: (state, action) => {
      state.filters.isReleased = action.payload;
    },
    setTileView: (state, action) => {
      state.tileView = action.payload; // Add reducer to update tileView
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchMolds.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMolds.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchMolds.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

     .addCase(fetchMoldsByStatus.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMoldsByStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchMoldsByStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addMold.fulfilled, (state, action) => {
        const newMold = {
          ...action.payload,
          isNewlyCreated: true,
        };
        state.data = [newMold, ...state.data];
      })
      .addCase(addMold.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(editMold.fulfilled, (state, action) => {
        const index = state.data.findIndex(s => s.id === action.payload.id);
        if (index !== -1) {
          state.data[index] = action.payload;
        }
      })
      .addCase(editMold.rejected, (state, action) => {
        state.error = action.payload;
      })
      // .addCase(deleteMold.fulfilled, (state, action) => {
      //   const newData = state.data.filter(s => s.id !== action.payload);
      //   state.data = newData;
      // })
      .addCase(editMoldData.pending, state => {
        state.receiveLoading = true;
      })
      .addCase(editMoldData.fulfilled, state => {
        state.receiveLoading = false;
      })
      .addCase(editMoldData.rejected, state => {
        state.receiveLoading = false;
      });
  },
});

redux.listener.startListening({
  matcher: isAnyOf(addMold.rejected, editMold.rejected, editMoldData.rejected),
  effect: (action, listenerApi) => {
    listenerApi.dispatch(
      showToast({
        message: action.payload,
        type: 'danger',
      }),
    );
  },
});

redux.listener.startListening({
  matcher: isAnyOf(addMold.fulfilled, editMold.fulfilled),
  effect: (action, listenerApi) => {
    listenerApi.dispatch(closeModal(MOLDRECEIVING_ADD_EDIT));
    listenerApi.dispatch(fetchMoldReceivingWithFilters());
    listenerApi.dispatch(
      showToast({
        message: 'Mold Received successfully',
        type: 'success',
      }),
    );
  },
});

redux.listener.startListening({
  matcher: isAnyOf(editMoldData.fulfilled),
  effect: (action, listenerApi) => {
    listenerApi.dispatch(showModal(MOLDRECEIVING_ADD_EDIT, action.payload));
  },
});

// redux.listener.startListening({
//   matcher: isAnyOf(deleteMold.fulfilled),
//   effect: (action, listenerApi) => {
//     listenerApi.dispatch(
//       showToast({
//         message: 'Mold deleted successfully',
//         type: 'success',
//       }),
//     );
//   },
// });

redux.injectReducer(STORE_KEY, reducer);
